function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32",
  transform: "translate(-415 -3733)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 31",
  cx: 37.5,
  cy: 37.5,
  r: 37.5,
  transform: "translate(415 3733)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon material-arrow-upward",
  d: "M430.074 3770.5l3.953 3.879 15.67-15.351v33.481h5.607v-33.481l15.642 15.379 3.981-3.907-22.427-22.009z",
  fill: "#f9cec8"
}));
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 75 75"
  }, props), _ref);
};
export default SvgArrowUp;